import { Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { loginPage } from '@/constants/loginPage';
import { AzureIcon } from './AzureIcon';

interface AzureLoginButtonProps {
  isLoading: boolean;
  disabled: boolean;
  onLogin: () => void;
}

export function AzureLoginButton({
  isLoading,
  disabled,
  onLogin,
}: AzureLoginButtonProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Button
      type="button"
      variant="contained"
      size="large"
      fullWidth
      disabled={disabled || isLoading}
      onClick={onLogin}
      aria-label={t('login.loginWithActiveDirectory')}
      startIcon={
        isLoading ? (
          <CircularProgress size={18} sx={{ color: 'inherit' }} aria-hidden />
        ) : (
          <AzureIcon />
        )
      }
      sx={{
        mt: 0.5,
        py: 1.35,
        borderRadius: 2,
        textTransform: 'none',
        bgcolor: loginPage.azureButtonBg,
        color: '#ffffff',
        boxShadow: '0 4px 14px rgba(15, 28, 46, 0.18)',
        transition: 'background-color 180ms ease, box-shadow 180ms ease, transform 120ms ease',
        '&:hover': {
          bgcolor: loginPage.azureButtonHoverBg,
          boxShadow: '0 6px 18px rgba(15, 28, 46, 0.22)',
        },
        '&:focus-visible': {
          outline: 'none',
          boxShadow: loginPage.azureButtonFocusRing,
        },
        '&.Mui-disabled': {
          bgcolor: loginPage.azureButtonBg,
          color: 'rgba(255, 255, 255, 0.72)',
          opacity: 0.85,
        },
        '& .MuiButton-startIcon': {
          marginRight: 1.25,
        },
      }}
    >
      {isLoading ? t('auth.authRedirectLoadingLabel') : t('login.loginWithActiveDirectory')}
    </Button>
  );
}
